(function() {

	"use strict";

	angular.module( "ATMGurus" )

	.directive( "dropdownInput", [
		"$timeout",
		"$filter",
		"User",
		function( $timeout, $filter, User ) {
			return {
				restrict:  "AE",
				template: require("../../templates/bits/input-dropdown.html"),
				scope: {
					data: "=",
					selection: "=",
				},
				controller: ["$scope", function( $scope ) {

					var userData = User.getUserData();

					// $scope.selection = userData.billingAddress.customer_name;
					$scope.dropdownVisible = false;

					$scope.toggleVisible = function( visible ) {
						$scope.dropdownVisible = typeof visible === 'undefined' ? !! $scope.dropdownVisible : visible;
					};

					$scope.select = function( item ) {
						$scope.selection = item;
						$scope.toggleVisible( false );
					};
				}],
				link: function( scope, element, attrs ) {

					var _data = scope.data;

					scope.debounceDropdownVisible = function() {
						$timeout( function() {
							scope.toggleVisible( false );
						}, 400 );
					};
				}
			};
		}
	]);
})();


// WEBPACK FOOTER //
// ./src/app/directives/dropdown-input.js